import { render } from "./Team.vue?vue&type=template&id=5b50d0f5&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=5b50d0f5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b50d0f5"

export default script